var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "share-config-container" }, [
    _c(
      "div",
      { staticClass: "left-panel" },
      [
        _c(
          "el-form",
          {
            ref: "form",
            attrs: { model: _vm.formData, "label-width": "120px" }
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "分享Logo:" } },
              [
                _c("upload-image", {
                  staticStyle: { display: "inline-block" },
                  attrs: {
                    "file-size": 200,
                    "is-press": true,
                    "max-w-h": 1080,
                    multiple: true,
                    "auto-upload": true,
                    height: "240px",
                    width: "300px",
                    tips: "图片长宽比是 5:4，自动压缩，不超过200kb"
                  },
                  on: { onUploadSuccess: _vm.imgUploadSuccess }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "分享标题" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入分享标题" },
                  on: {
                    change: function($event) {
                      _vm.editable = true
                    }
                  },
                  model: {
                    value: _vm.formData.titleDictRow.label,
                    callback: function($$v) {
                      _vm.$set(_vm.formData.titleDictRow, "label", $$v)
                    },
                    expression: "formData.titleDictRow.label"
                  }
                })
              ],
              1
            ),
            _vm.editable
              ? _c(
                  "div",
                  { staticClass: "bottom-btns" },
                  [
                    _vm.editable
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: { click: _vm.init }
                          },
                          [_vm._v("取消")]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success" },
                        on: { click: _vm.saveEdit }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _c("div", { staticClass: "right-panel" }, [
      _c("h3", [_vm._v("微信小程序分享预览")]),
      _c("div", { staticClass: "preview-container" }, [
        _c("div", { staticClass: "preview-box" }, [
          _c("div", { staticClass: "preview-title" }, [
            _c("p", [_vm._v(_vm._s(_vm.formData.titleDictRow.label))])
          ]),
          _c("img", {
            staticClass: "preview-img",
            attrs: { src: _vm.formData.logoDictRow.label, alt: "Logo" }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }